import moment from 'moment';

const formatDate = (datestring: string | Date, format?: string): string => moment(datestring)
  .format(format)
  .toLocaleLowerCase();

export const stripTime = (date: string) => {
  const dateObj = new Date(date);
  return dateObj.toISOString().replace(/T.*/, '');
};

export const getDaysDifference = (dateBefore: string, dateAfter: string) => {
  const oneDay = 24 * 60 * 60 * 1000;

  const before = new Date(dateBefore);
  const after = new Date(dateAfter);

  return Math.floor((after.getTime() - before.getTime()) / oneDay);
};

export default formatDate;
